import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

const SendScoreComponent = ({ port }) => {
  const ip = document.getElementById('ip').value;
  const scoreHead = `set_option("outdevice=net:${ip}:${port}")
rtsetparams(44100,2,1024)
`;
  const [score, setScore] = useState(scoreHead);
  const [status, setStatus] = useState(1);
  return (
    <div style={{minWidth: '400px'}}>
      <div>
        <Status status={status} /> {port}
      </div>
      <Form.Control type="file" size='sm' onChange={e=>{
        if (!e.currentTarget.files.length) return;
        let fr = new FileReader();
        fr.onload = () => {
            setScore(scoreHead+fr.result);
        };
        fr.readAsText(e.currentTarget.files[0]);
      }} />
      <Form.Control as="textarea" rows={8}
        style={{resize: 'both', fontFamily: 'monospace'}}
        value={score}
        onChange={e => setScore(e.target.value)}
      />
      {score ? (
        <div style={{textAlign: 'center'}}>
          <Button
            onClick={() => {
              if (status === -1) return;
              setStatus(-1);
              let formData = new FormData();
              formData.append(
                "file",
                new Blob([score], { type: "text/plain" }),
                "file.sco"
              );
              fetch("http://127.0.0.1:8080/uploadFile", {
                method: "POST",
                body: formData,
              }).finally(() => setStatus(1));
            }}
          >
            Send
          </Button>
        </div>
      ) : ''}
    </div>
  );
};

const Status = ({ status }) => {
  return (
    <span
      style={{
        width: "15px",
        height: "15px",
        display: "inline-block",
        margin: "0 1px",
        border: "1px solid black",
        borderRadius: "99px",
        backgroundColor:
          status === 1 ? "green" : status === 0 ? "lightgrey" : "red",
      }}
    ></span>
  );
};

export default SendScoreComponent;
